export default __webpack_public_path__ + "e02597596303d1bb068d6a470d0919b0.svg";